import React, { useState } from 'react';
import { Copy, Check, QrCode, Link } from 'lucide-react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ReferralLinkCard = ({ referralCode, referralLink, onCopyLink, copiedLink }) => {
  const [showQR, setShowQR] = useState(false);

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-6 shadow-therapeutic-sm">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon name="Link" size={24} className="text-primary" />
        </div>
        <div>
          <h2 className="text-lg font-heading font-bold text-foreground">Your Referral Link</h2>
          <p className="text-sm text-muted-foreground">Share this link to invite friends</p>
        </div>
      </div>

      {/* Referral Code Display */}
      <div className="bg-gray-50 rounded-lg p-4 mb-4">
        <label className="text-xs font-semibold text-muted-foreground uppercase tracking-wide mb-2 block">
          Referral Code
        </label>
        <div className="flex items-center gap-2">
          <code className="text-2xl font-bold font-mono text-primary tracking-wider">
            {referralCode}
          </code>
        </div>
      </div>

      {/* Referral Link Display */}
      <div className="bg-gray-50 rounded-lg p-4 mb-4">
        <label className="text-xs font-semibold text-muted-foreground uppercase tracking-wide mb-2 block">
          Referral Link
        </label>
        <div className="flex items-center gap-2">
          <input
            type="text"
            value={referralLink}
            readOnly
            className="flex-1 bg-white border border-gray-300 rounded-lg px-3 py-2 text-sm text-foreground font-mono"
          />
          <Button
            variant={copiedLink ? 'success' : 'default'}
            size="sm"
            onClick={onCopyLink}
            iconName={copiedLink ? 'Check' : 'Copy'}
          >
            {copiedLink ? 'Copied!' : 'Copy'}
          </Button>
        </div>
      </div>

      {/* QR Code Toggle */}
      <div className="flex items-center justify-between pt-4 border-t border-gray-200">
        <div className="flex items-center gap-2">
          <Icon name="QrCode" size={20} className="text-muted-foreground" />
          <span className="text-sm text-foreground">QR Code for mobile sharing</span>
        </div>
        <Button
          variant="outline"
          size="sm"
          onClick={() => setShowQR(!showQR)}
        >
          {showQR ? 'Hide' : 'Show'}
        </Button>
      </div>

      {/* QR Code Display */}
      {showQR && (
        <div className="mt-4 p-6 bg-gray-50 rounded-lg text-center">
          <div className="w-48 h-48 bg-white border-2 border-gray-300 rounded-lg mx-auto flex items-center justify-center">
            <div className="text-center">
              <Icon name="QrCode" size={64} className="text-gray-400 mx-auto mb-2" />
              <p className="text-xs text-muted-foreground">QR Code Generation</p>
              <p className="text-xs text-muted-foreground">Coming Soon</p>
            </div>
          </div>
          <p className="text-xs text-muted-foreground mt-3">
            Scan this code to share your referral link instantly
          </p>
        </div>
      )}
    </div>
  );
};

export default ReferralLinkCard;